<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useRuleEnginedStore } from "@/modules/rule_engine/store";

/**
 * Undo/redo for the rule model being edited. Reads the store directly so every
 * builder shell can drop it in without wiring up the history itself.
 */

const { t } = useI18n();
const store = useRuleEnginedStore();
</script>

<template>
	<div class="d-flex ga-1">
		<v-btn
			icon="mdi-undo"
			variant="text"
			density="comfortable"
			:disabled="!store.canUndo"
			v-tooltip="t('rule_engine.history.undo')"
			@click="store.undo()"
		/>
		<v-btn
			icon="mdi-redo"
			variant="text"
			density="comfortable"
			:disabled="!store.canRedo"
			v-tooltip="t('rule_engine.history.redo')"
			@click="store.redo()"
		/>
	</div>
</template>
